import React, { useState } from "react";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebase";
import {
  TextField,
  Button,
  Grid,
  Container,
  IconButton,
  Typography,
  Card,
  CardContent,
  Snackbar,
  Alert,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DynamicUploadModal from "../../../components/UploadModal";

const AddSymptom = () => {
  const [openModal, setOpenModal] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleUploadSuccess = (url) => {
    console.log("Image uploaded successfully! URL:", url);
    setUploadedImageUrl(url);
    setSymptom((prevData) => ({
      ...prevData,
      imageUrl: url,
    }));
  };

  const [symptom, setSymptom] = useState({
    description: "",
    id: uuidv4(), // Generate a unique ID
    imageUrl: "",
    name: "",
    status: "live",
    timestamp: serverTimestamp(), // Dynamically set to the Firestore server timestamp
    docRefId: "", // Field for document reference ID
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSymptom((prevSymptom) => ({
      ...prevSymptom,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const symptomData = {
      ...symptom,
      timestamp: serverTimestamp(), // Update timestamp to Firestore server timestamp
    };

    try {
      // Set the docRefId to the same as id or use a new one if needed
      symptomData.docRefId = symptom.id;

      await setDoc(doc(db, "symptoms", symptom.id), symptomData);
      setOpenSnackbar(true);
      setSymptom({
        description: "",
        id: uuidv4(), // Reset to a new unique ID
        imageUrl: "",
        name: "",
        status: "live",
        timestamp: serverTimestamp(), // Reset the timestamp dynamically
        docRefId: "", // Reset docRefId
      });
    } catch (error) {
      console.error("Error adding symptom: ", error);
      alert("Error adding symptom");
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Add New Symptom
          </Typography>
          
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={symptom.name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  name="description"
                  value={symptom.description}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="ID"
                  name="id"
                  value={symptom.id}
                  onChange={handleChange}
                  required
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Image URL"
                  name="imageUrl"
                  value={uploadedImageUrl}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <IconButton
                  onClick={() => setOpenModal(true)}
                  color="primary"
                  aria-label="upload image"
                >
                  <PhotoCamera />
                </IconButton>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  fullWidth
                >
                  Add Symptom
                </Button>
              </Grid>
            </Grid>
          </form>

          <DynamicUploadModal
            open={openModal}
            onClose={handleModalClose}
            uploadPreset="bookMyDr" // Custom Cloudinary upload preset
            folderName="Madecare" // Custom folder name
            maxSize={5 * 1024 * 1024} // Custom max file size: 5MB
            onUploadSuccess={handleUploadSuccess} // Callback after success
          />
        </CardContent>
      </Card>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          Symptom added successfully!
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default AddSymptom;
